export default "__VITE_ASSET__34c55060__"